/* LUMÉ – interacciones (sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.lm-reveal:not(.lm-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lm-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-lm-contar]');
    if (!nums.length) return;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-lm-contar')) || 0;
      var dur = parseInt(el.getAttribute('data-lm-duracion'), 10) || 1800;
      if (reducido) { el.textContent = fin; return; }
      var t0 = null;
      var paso = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function initEscenas() {
    document.querySelectorAll('[data-lm-escena]').forEach(function (escena) {
      var pasos = escena.querySelectorAll('.lm-paso');
      var imgs = escena.querySelectorAll('.lm-escena__media img');
      var contador = escena.querySelector('[data-lm-contador]');
      if (!pasos.length) return;
      var activar = function (i) {
        pasos.forEach(function (p, j) { p.classList.toggle('lm-activa', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('lm-activa', i === j); });
        if (contador) contador.textContent = String(i + 1).padStart(2, '0');
      };
      activar(0);
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  function initTilt() {
    if (reducido || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-lm-tilt]').forEach(function (zona) {
      var obj = zona.querySelector('.lm-hero__tilt');
      if (!obj) return;
      var fuerza = parseFloat(zona.getAttribute('data-lm-tilt')) || 8;
      zona.addEventListener('mousemove', function (ev) {
        var r = zona.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        obj.style.transform = 'perspective(1000px) rotateY(' + (x * fuerza) + 'deg) rotateX(' + (-y * fuerza) + 'deg)';
      });
      zona.addEventListener('mouseleave', function () { obj.style.transform = ''; });
    });
  }

  function formatoDinero(centimos) {
    var f = (window.lmFormatoMoneda || '{{amount_with_comma_separator}} €');
    var n = (centimos / 100).toFixed(2);
    var conComa = n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
            .replace(/\{\{\s*amount\s*\}\}/, n)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(centimos / 100));
  }

  function initProducto() {
    document.querySelectorAll('[data-lm-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('script[data-lm-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var principal = raiz.querySelector('[data-lm-principal]');
      var minis = raiz.querySelectorAll('[data-lm-mini]');

      var mostrar = function (src, srcset, boton) {
        if (!principal || principal.getAttribute('src') === src) return;
        principal.classList.add('lm-cambiando');
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.classList.remove('lm-cambiando');
        }, 220);
        minis.forEach(function (m) { m.setAttribute('aria-current', m === boton ? 'true' : 'false'); });
      };
      minis.forEach(function (b) {
        b.addEventListener('click', function () { mostrar(b.getAttribute('data-src'), b.getAttribute('data-srcset'), b); });
      });

      var radios = raiz.querySelectorAll('[data-lm-opcion]');
      if (!radios.length) return;
      var actualizar = function () {
        var elegidas = [];
        raiz.querySelectorAll('fieldset.lm-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
          var rot = fs.querySelector('[data-lm-elegido]');
          if (rot && c) rot.textContent = c.getAttribute('data-label') || c.value;
        });
        var v = variantes.find(function (va) {
          return va.options.every(function (o, i) { return o === elegidas[i]; });
        });
        var btns = document.querySelectorAll('[data-lm-boton-compra]');
        if (!v) {
          btns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); var s = b.querySelector('span'); if (s) s.textContent = b.getAttribute('data-txt-nodisp'); });
          return;
        }
        document.querySelectorAll('[data-lm-variante-id]').forEach(function (inp) { inp.value = v.id; });
        document.querySelectorAll('[data-lm-precio]').forEach(function (p) { p.textContent = formatoDinero(v.price); });
        document.querySelectorAll('[data-lm-precio-antes]').forEach(function (p) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          p.textContent = hay ? formatoDinero(v.compare_at_price) : '';
          p.hidden = !hay;
        });
        document.querySelectorAll('[data-lm-ahorro]').forEach(function (a) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          a.hidden = !hay;
          if (hay) a.textContent = a.getAttribute('data-plantilla').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
        });
        btns.forEach(function (b) {
          var s = b.querySelector('span');
          if (v.available) { b.removeAttribute('disabled'); if (s) s.textContent = b.getAttribute('data-txt-comprar'); }
          else { b.setAttribute('disabled', 'disabled'); if (s) s.textContent = b.getAttribute('data-txt-agotado'); }
        });
        if (v.featured_media && v.featured_media.src) {
          var boton = raiz.querySelector('[data-lm-mini][data-media-id="' + v.featured_media.id + '"]');
          mostrar(v.featured_media.src, '', boton);
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      };
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-lm-barra]');
    var ancla = document.querySelector('[data-lm-ancla-compra]');
    if (!barra || !ancla) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { barra.classList.toggle('lm-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    });
    io.observe(ancla);
  }

  function init() { initReveal(); initCifras(); initEscenas(); initTilt(); initProducto(); initBarra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCifras(); initEscenas(); initTilt(); initProducto(); initBarra(); });
})();
